import { scrollIntoView } from 'scroll-js';
import { mediaQuery } from '../../../../global/js/wlc/mediaQuery';
let normalizeWheel = require('normalize-wheel');

export let fixedScrollMixinPage = {
	initFixedScrollMixin: (self, blocks = null) => {
		self.$element = self.$element || $(self.element);
		self.$tplScroller = self.$tplScroller || $('.tpl-scroller');
		self.$tplHeader = self.$tplHeader || $('.tpl-header');
		self.$tplFooter = self.$tplFooter || $('.tpl-footer');

		let isScrolling = false; // Flag for scrolling, can’t scroll if set to false
		let fixedScroll = self.$element.data('fixed-scroll'); // Attribute to enable / disable fixed scroll
		let scrollDuration = 750;
		let scrollEasing = 'ease-in-out';
		let fixedScrollItems = [];
		let fixedScrollActiveItemIndex = 0;
		let $sectionFixedScrollContainer = $('[data-section-fixed-scroll-container]');
		let $sectionFixedScrollItems = [];

		if(_.isNil(blocks)) {
			blocks = $sectionFixedScrollContainer.children().toArray();
		}

		// Sets attributes to latch events and styling onto the fixed scroll
		let setAttributes = () => {
			// Apply a section-fixed-scroll-item attribute to target against
			fixedScrollItems.forEach((element) => {
				if(element === self.$tplFooter[0]) {
					// Add a fixed scroll event to the footer as this is the only element that is outside the fixed-scroll-container
					$(element).attr('fixed-scroll-event', '');
				}
				else {
					// Insert an inner element with the section-fixed-scroll-item attribute
					// This is because inside the item we a tweaking to a full height
					$(element).attr('section-fixed-scroll-item', '');
					$(element).wrapInner('<div section-fixed-scroll-item-inner fixed-scroll-event></div>');
				}
			});

			$sectionFixedScrollItems = $sectionFixedScrollContainer.find('[section-fixed-scroll-item]');
		};

		// Enables/disables fixed scroll on mobile screens and handles the sizes dependant on viewport height & width.
		let setSectionResizeEvent = () => {
			let resizeEvent = () => {
				if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.SM)) {
					self.$tplScroller.css({
						overflowY: 'hidden'
					});

					$sectionFixedScrollItems.each((index, element) => {
						let $fixedScrollItem = $(element);
						let $fixedScrollItemInner = $fixedScrollItem.find(`[section-fixed-scroll-item-inner]`);

						// Reset the values
						$fixedScrollItem.css({
							height: 'initial'
						});

						$fixedScrollItemInner.css({
							flex: '1 1 auto'
						});

						// Prevents bouncing scroll on iOS devices
						$fixedScrollItemInner.on('touchmove', (event) => {
							event.preventDefault();
						});

						if($fixedScrollItemInner.outerHeight() >= self.$tplScroller[0].clientHeight) {
							$fixedScrollItem.css({
								height: self.$tplScroller[0].clientHeight
							});

							$fixedScrollItemInner.css({
								'minHeight': '100%',
								'overflowY': 'scroll',
								'flex': '1 1 auto'
							});
						}
						else {
							$fixedScrollItem.css({
								height: 'initial'
							});

							$fixedScrollItemInner.css({
								flex: '1 1 auto'
							});
						}
					});
				}
				else {
					self.$tplScroller.css({
						overflowY: 'scroll'
					});

					$sectionFixedScrollItems.each((index, element) => {
						let $fixedScrollItem = $(element);
						let $fixedScrollItemInner = $fixedScrollItem.find(`[section-fixed-scroll-item-inner]`);

						$fixedScrollItem.css({
							height: 'unset'
						});

						$fixedScrollItemInner.css({
							height: 'unset',
							overflowY: 'unset',
							flex: 'unset'
						});
					});
				}
			};

			$(window).on('resize.fixedScrollMixin', _.debounce(() => {
				resizeEvent();
			}, 250, { leading: false, trailing: true }));

			setTimeout(() => {
				resizeEvent();
			}, 250);
		};

		// Sets the default styles for the fixedScrollItems
		let setSectionStyles = () => {
			$sectionFixedScrollItems.each((index, element) => {
				let $fixedScrollItem = $(element);
				let $fixedScrollItemInner = $fixedScrollItem.find(`[section-fixed-scroll-item-inner]`);

				$fixedScrollItem.css({
					width: '100%',
					position: 'relative'
				});

				$fixedScrollItemInner.css({
					width: '100%'
				});
			});
		};

		let setFixedScrollEvent = () => {
			self.$fixedScrollEvent = $('[fixed-scroll-event]');

			let isElementScrollable = ($element) => {
				return $element.children()[0].clientHeight > self.$tplScroller[0].clientHeight;
			};

			let isElementScrollAtTop = ($element) => {
				return $element[0].scrollTop <= 0;
			};

			let isElementScrollAtBottom = ($element) => {
				return (Math.ceil($element[0].scrollTop) >= ($element[0].scrollHeight - $element[0].offsetHeight));
			};

			let isScrollLocked = ($element) => {
				return $element[0].hasAttribute('fixed-scroll-event-lock');
			};

			// Ensure that the active index is the element that is selected to scroll
			let updateScrolledIndex = ($element) => {
				let scrolledIndex;
				// If the selected element is the element before the tplFooter element and the active index is the tplFooter element
				if(fixedScrollItems[fixedScrollItems.length - 2] &&
					fixedScrollItems[fixedScrollItems.length - 2] === $element[0] && (fixedScrollActiveItemIndex === fixedScrollItems.length - 1)) {
					scrolledIndex = fixedScrollItems.length - 1;
				}
				else {
					scrolledIndex = _.findIndex(fixedScrollItems, (fixedScrollElement) => {
						if(fixedScrollElement === self.$tplFooter[0]) {
							return fixedScrollElement === $element[0];
						}
						// Return the current selected element
						else {
							return fixedScrollElement === $element.parents('[section-fixed-scroll-item]')[0];
						}
					});
				}

				setFixedScrollActiveItemIndex(scrolledIndex);
			};

			// Normal desktop devices scrolling event
			self.$fixedScrollEvent.on('DOMMouseScroll.fixedScrollMixin wheel.fixedScrollMixin scroll.fixedScrollMixin', _.throttle((event) => {
				let pixelThreshold = 5;
				if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.SM) && !isScrolling) {
					isScrolling = true;
					let nomalizeWheelValue = normalizeWheel(event.originalEvent);
					let pixelY = nomalizeWheelValue.pixelY;
					let $element = $(event.currentTarget);

					// Prevent scrolling that is triggered in certain elements that have an inner scroll.
					let lockScroll = isScrollLocked($element);

					updateScrolledIndex($element);

					let isScrollingUp = () => {
						return pixelY < (pixelThreshold * -1);
					};

					let isScrollingDown = () => {
						return pixelY > pixelThreshold;
					};

					// There is a scrollable element inside the section
					if(isElementScrollable($element)) {
						// Scrolled to the top of the section scroll item and the scroll direction is up
						if(isElementScrollAtTop($element) && isScrollingUp() && !lockScroll) {
							scrollToPreviousSection();
						}
						// Scrolled to the bottom of the section scroll item and the scroll direction is down
						else if(isElementScrollAtBottom($element) &&
							isScrollingDown() && !lockScroll) {
							scrollToNextSection();
						}
						else {
							isScrolling = false;
						}
					}
					// There isn’t a scrollable event inside the section
					else {
						// Scroll up
						if(isScrollingUp() && !lockScroll) {
							scrollToPreviousSection();
						}
						// Scroll down
						else if(isScrollingDown() && !lockScroll) {
							scrollToNextSection();
						}
						else {
							isScrolling = false;
						}
					}
				}
			}, 250, { leading: false, trailing: true }));

			// Deals with touch devices that don’t trigger scroll events
			(() => {
				let clientY;
				let deltaThreshold = 75;

				self.$fixedScrollEvent.on('touchstart.fixedScrollMixin',  _.debounce((event) => {
					clientY = event.touches[0].clientY;
				}, 250, { leading: true, trailing: false }));

				self.$fixedScrollEvent.on('touchend.fixedScrollMixin', _.debounce((event) => {
					let deltaY = event.changedTouches[0].clientY - clientY;

					if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.SM) && !isScrolling) {
						isScrolling = true;
						let $element = $(event.currentTarget);

						// Prevent scrolling that is triggered in certain elements that have an inner scroll.
						let lockScroll = isScrollLocked($element);

						updateScrolledIndex($element);

						let isScrollingUp = () => {
							return deltaY > deltaThreshold;
						};

						let isScrollingDown = () => {
							return deltaY < (deltaThreshold * -1);
						};

						// There is a scrollable element inside the section
						if(isElementScrollable($element)) {
							// Scrolled to the top of the section scroll item and the scroll direction is up
							if(isElementScrollAtTop($element) && isScrollingUp() && !lockScroll) {
								scrollToPreviousSection();
							}
							// Scrolled to the bottom of the section scroll item and the scroll direction is down
							else if(isElementScrollAtBottom($element) &&
								isScrollingDown() && !lockScroll) {
								scrollToNextSection();
							}
							else {
								isScrolling = false;
							}
						}
						// There isn’t a scrollable event inside the section
						else {
							// Scroll up
							if(isScrollingUp() && !lockScroll) {
								scrollToPreviousSection();
							}
							// Scroll down
							else if(isScrollingDown() && !lockScroll) {
								scrollToNextSection();
							}
							else {
								isScrolling = false;
							}
						}
					}
				}, 250, { leading: false, trailing: true }));
			})();
		};

		let setFixedScrollActiveItemIndex = (index) => {
			fixedScrollActiveItemIndex = index;
		};

		let setFixedScrollActiveElement = () => {
			fixedScrollItems.forEach((element, index) => {
				if(0 >= Math.floor($(element).position().top)) {
					fixedScrollActiveItemIndex = index;
				}
			});

			// Deals with footer as an active element index
			let $lastScrollElement = $(fixedScrollItems[fixedScrollItems.length - 1]);
			if(Math.floor(self.$tplScroller.outerHeight()) >= (Math.floor($lastScrollElement.position().top + $lastScrollElement.outerHeight()) - 1)) {
				fixedScrollActiveItemIndex = fixedScrollItems.length - 1;
			}
		};

		// Animate the scroll only when the oldActiveElementIndex isnt the same as the current activeElementIndex
		// This fixes the scrollPositioning of each section so that it is seemless
		let adjustSectionItemsScrollPosition = (oldElementIndex) => {
			if(oldElementIndex !== fixedScrollActiveItemIndex) {
				$sectionFixedScrollItems.each((index, element) => {
					let $fixedScrollItemInner = $(element).find(`[section-fixed-scroll-item-inner]`);
					let fixedScrollInnerElement = $fixedScrollItemInner[0];
					if(index < fixedScrollActiveItemIndex) {
						// Scroll this sections scroll to the bottom
						fixedScrollInnerElement.scrollTop = fixedScrollInnerElement.scrollHeight - fixedScrollInnerElement.clientHeight;
					}
					else if(index > fixedScrollActiveItemIndex) {
						// Scroll this sections scroll to the top
						$fixedScrollItemInner[0].scrollTop = 0;
					}
					// Only scroll the current section when not scrolling
					else if(!isScrolling) {
						if(oldElementIndex < fixedScrollActiveItemIndex) {
							// Scroll this sections scroll to the top when the oldElementIndex is less then the current element index
							$fixedScrollItemInner[0].scrollTop = 0;
						}
						else if(oldElementIndex > fixedScrollActiveItemIndex) {
							// Scroll this sections scroll to the bottom
							$fixedScrollItemInner[0].scrollTop = fixedScrollInnerElement.scrollHeight - fixedScrollInnerElement.clientHeight;
						}
					}
				});
			}
		};

		// tplScroller is invoked when the sectionNavigator widget is clicked or when the element scroll event in $sectionFixedScrollItems is triggered
		let setTplScrollerEvent = () => {
			self.$tplScroller.on('scroll.fixedScrollMixin touchmove.fixedScrollMixin', _.throttle(() => {
				let oldElementIndex = fixedScrollActiveItemIndex;

				// Trailing duration
				setTimeout(() => {
					setFixedScrollActiveElement();
					adjustSectionItemsScrollPosition(oldElementIndex);
				}, scrollDuration);
			}, scrollDuration, { leading: true, trailing: false }));
		};

		let scrollToElementIndex = (index) => {
			let section = fixedScrollItems[index];

			// Hide tooltip if exists
			if($('#notepadTooltip').length) {
				$('#notepadTooltip').hide();
			}

			// Existing scroll into view
			scrollIntoView(section, self.$tplScroller[0], { duration: scrollDuration, easing: scrollEasing }).finally(() => {
				setFixedScrollActiveItemIndex(index);
				setTimeout(() => {
					isScrolling = false;
				}, scrollDuration + 100);
			});
		};

		// Scrolls to the previous index
		let scrollToPreviousSection = () => {
			let prevElementIndex = fixedScrollActiveItemIndex - 1;

			if(prevElementIndex >= 0) {
				scrollToElementIndex(prevElementIndex);
			}
			// Edge case for when the footer is displayed
			else if(fixedScrollActiveItemIndex === 0) {
				scrollToElementIndex(0);
			}
			else {
				isScrolling = false;
			}
		};

		// Scrolls to the next index
		let scrollToNextSection = () => {
			let nextElementIndex = fixedScrollActiveItemIndex + 1;

			if(nextElementIndex <= (fixedScrollItems.length - 1)) {
				scrollToElementIndex(nextElementIndex);
			}
			else {
				isScrolling = false;
			}
		};

		// Remove scrolling events when sections are inactive. Deals with courseAssessmentPage where fixedScrollItems are re-instantiated
		let unsetEvents = () => {
			self.$tplScroller.off('scroll.fixedScrollMixin touchmove.fixedScrollMixin');

			if(self.$fixedScrollEvent &&self. $fixedScrollEvent.length > 0) {
				self.$fixedScrollEvent.off('touchstart.fixedScrollMixin touchend.fixedScrollMixin DOMMouseScroll.fixedScrollMixin wheel.fixedScrollMixin scroll.fixedScrollMixin');
			}

			$(window).off('resize.fixedScrollMixin');
		};

		if(blocks.length > 0) {
			fixedScrollItems = [...blocks, self.$tplFooter[0]];

			if(fixedScroll) {
				// Remove old events
				unsetEvents();

				// Prevents scroll bouncing for Mac devices
				$('html').css({
					overflow: 'hidden'
				});

				self.$tplScroller.css({
					overflowY: 'hidden'
				});
				// Deals with targeting alongside overlay.js file. This is then lower priority class than an inline “overflow: hidden !important”.

				setAttributes();
				setSectionResizeEvent();
				setSectionStyles();
				setFixedScrollEvent();
				setTplScrollerEvent();
			}
		}
		else {
			console.error('FixedScrollMixin::Error', 'Please insert a list of element to be used for the FixedScrollMixin');
		}
	},
};
